import request from '../utils/request'

export const listOperationLogs = params => request.get('/operation-logs', { params })
